import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-17be156e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src"]
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["src"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 1,
  class: "service-list"
}
const _hoisted_6 = { class: "service-item" }
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "item-title" }
const _hoisted_10 = { class: "h-t" }
const _hoisted_11 = {
  key: 0,
  class: "h-time"
}
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  key: 3,
  class: "item-des"
}
const _hoisted_14 = {
  key: 0,
  class: "item-des-d"
}
const _hoisted_15 = {
  key: 4,
  class: "callback-info"
}
const _hoisted_16 = { class: "callback-item" }
const _hoisted_17 = {
  key: 5,
  class: "callback-info"
}
const _hoisted_18 = { class: "callback-item" }
const _hoisted_19 = { class: "callback-item" }
const _hoisted_20 = { class: "callback-item" }
const _hoisted_21 = { class: "callback-item" }
const _hoisted_22 = { class: "callback-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_space = _resolveComponent("a-space")!
  const _component_table_wrapper = _resolveComponent("table-wrapper")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, { class: "mb50" }, {
    default: _withCtx(() => [
      (_ctx.showTable)
        ? (_openBlock(), _createBlock(_component_table_wrapper, {
            key: 0,
            "row-key": 'uuid',
            ref: "tableWrappers",
            dataSource: _ctx.value,
            showCheckbox: true,
            columns: _ctx.detailColumns
          }, {
            buttons: _withCtx(() => [
              _createVNode(_component_a_space)
            ]),
            isPhotograph: _withCtx(({ record }) => [
              (record.isPhotograph == 1)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "tb-img",
                    src: _ctx.isZHXH ? _ctx.checkRightGreen : _ctx.checkRight,
                    alt: ""
                  }, null, 8, _hoisted_1))
                : (_openBlock(), _createElementBlock("span", _hoisted_2, "-"))
            ]),
            isExplain: _withCtx(({ record }) => [
              (record.isExplain == 1)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    class: "tb-img",
                    src: _ctx.isZHXH ? _ctx.checkRightGreen : _ctx.checkRight,
                    alt: ""
                  }, null, 8, _hoisted_3))
                : (_openBlock(), _createElementBlock("span", _hoisted_4, "-"))
            ]),
            _: 1
          }, 8, ["dataSource", "columns"]))
        : _createCommentVNode("", true),
      (_ctx.value && !_ctx.showTable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.value, (item, index) => {
              return (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (index == 0)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["round", { grey: !item?.finishedFlag }])
                    }, [
                      _createElementVNode("b", {
                        class: _normalizeClass({ grey: !item?.finishedFlag })
                      }, null, 2)
                    ], 2))
                  : (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      class: _normalizeClass(["round", { grey: !item?.finishedFlag }])
                    }, [
                      (!!item?.finishedFlag)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.isZHXH ? _ctx.IconCheckedGreen : _ctx.IconChecked
                          }, null, 8, _hoisted_7))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            src: _ctx.IconCheckedGrey
                          }, null, 8, _hoisted_8))
                    ], 2)),
                _createElementVNode("h5", _hoisted_9, [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(item?.workPackagesName), 1),
                  (item?.workDetails)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item?.workDetails?.lastModifiedTime), 1))
                    : _createCommentVNode("", true)
                ]),
                (item?.workDetails)
                  ? (_openBlock(), _createBlock(_component_a_row, {
                      key: 2,
                      class: "item-imgs",
                      gutter: [16, 10]
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item?.workDetails?.imageUrlList, (imgs) => {
                          return (_openBlock(), _createElementBlock(_Fragment, null, [
                            imgs
                              ? (_openBlock(), _createBlock(_component_a_col, {
                                  key: 0,
                                  span: 8,
                                  class: "item-img"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", null, [
                                      _createElementVNode("img", {
                                        src: imgs,
                                        alt: ""
                                      }, null, 8, _hoisted_12)
                                    ])
                                  ]),
                                  _: 2
                                }, 1024))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 256))
                      ]),
                      _: 2
                    }, 1024))
                  : _createCommentVNode("", true),
                (item?.workDetails)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      (item?.workDetails.remark)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(item?.workDetails.remark), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                (item?.workPackagesName == '客户验收' && item?.ticketSatisfaction)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, "满意度：" + _toDisplayString(item.ticketSatisfactionDesc), 1)
                    ]))
                  : _createCommentVNode("", true),
                (item?.ticketCallBackInfoResp)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createElementVNode("span", _hoisted_18, "回访人：" + _toDisplayString(item.ticketCallBackInfoResp.callBackUserName), 1),
                      _createElementVNode("span", _hoisted_19, "回访方式：" + _toDisplayString(item.ticketCallBackInfoResp.callBackTypeDesc), 1),
                      _createElementVNode("span", _hoisted_20, "问题解决情况：" + _toDisplayString(item.ticketCallBackInfoResp.problemResolutionStatusDesc), 1),
                      _createElementVNode("span", _hoisted_21, "发生费用：" + _toDisplayString(item.ticketCallBackInfoResp.repairCosts != null ? item.ticketCallBackInfoResp.repairCosts + ' 元' : '-'), 1),
                      _createElementVNode("span", _hoisted_22, "备注：" + _toDisplayString(item.ticketCallBackInfoResp.remark || '-'), 1)
                    ]))
                  : _createCommentVNode("", true),
                (index != _ctx.value.length - 1)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 6,
                      class: _normalizeClass(["line", { grey: !item?.workDetails }])
                    }, null, 2))
                  : _createCommentVNode("", true)
              ]))
            }), 256))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}